import React, { createContext, useState } from "react";

type T = {
  shareCartId: string | null;
  setShareCartId: (_id: string | null) => void;
};

export const ShareCartContext = createContext<T>({
  shareCartId: null,
  setShareCartId: (_id) => {},
});

const ShareCartContextProvider = (props) => {
  const [shareCartId, setShareCartId] = useState<string | null>(null);

  return (
    <ShareCartContext.Provider
      value={{
        shareCartId,
        setShareCartId,
      }}
    >
      {props.children}
    </ShareCartContext.Provider>
  );
};

export default ShareCartContextProvider;
